import React, { forwardRef } from 'react';
import { adCard as c } from '../../component-classes';

type AdLinkProps = {
    children?: React.ReactNode;
    className?: string;
    href: string;
    onClick?: (event: React.MouseEvent) => void;
} & Omit<
    React.PropsWithoutRef<JSX.IntrinsicElements['a']>,
    // omit href here, because we don't want href to be optional
    'href'
>;

const AdLink = forwardRef<HTMLAnchorElement, AdLinkProps>(
    (props, forwardedRef) => {
        const { children, className = '', href, onClick, ...linkProps } = props;

        return (
            <a
                ref={forwardedRef}
                className={`${c.link} ${className}`}
                href={href}
                onClick={onClick}
                onAuxClick={
                    onClick
                        ? (event) => {
                              if (event.button === 1) {
                                  // Middle mouse button has been clicked
                                  onClick(event);
                              }
                          }
                        : undefined
                }
                {...linkProps}
            >
                {children}
            </a>
        );
    },
);

export default AdLink;
